// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#wrapper[data-v-d43137a6] {\n  background: #f8f8f8;\n  height: 125px;\n}\n#wrapper .dz-message[data-v-d43137a6] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
